<template>
  <div class="solfigrf-ranges solfigrplayers">
    <GwTitleTooltip
      class="solfigrplayers_title"
      :title="$t('solfigr.ranges.title')"
      :tooltip="$t('solfigr.ranges.title_tooltip')"
    />
    <div class="solfigrplayers_content">
      <SolfigrPlayer
        v-for="player in players"
        :key="player.position"
        :loading="loading"
        :item="player"
        :canRemove="player.canRemove"
        class="gw_btn_hover_back"
        style="--ra-table-size: var(--player-table-size)"
        :data-tst="`player${player.position}`"
        @click="$emit('click', player.position)"
        @remove:player="$emit('click:remove')"
      />
      <SolfigrAddPlayer
        v-if="shouldShowAddPlayerButton"
        @click="$emit('click:add')"
      />
    </div>
  </div>
</template>

<script>
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import SolfigrPlayer from '@/components/ConfigureSolution/SolfigrPlayer'
import SolfigrAddPlayer from '@/components/ConfigureSolution/SolfigrAddPlayer'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SolfigrPlayers',
  components: {
    SolfigrPlayer,
    GwTitleTooltip,
    SolfigrAddPlayer,
  },
  mixins: [float_mix],
  props: {
    gameformat: Object,
    readOnly: Boolean,
    instaApply: Boolean,
    shortcut: Object,
    loading: Boolean,
    blurred: Boolean,
    players: Array,
    shouldShowAddPlayerButton: Boolean,
  },
  emits: ['click', 'click:add', 'click:remove'],
}
</script>

<style lang="scss" scoped>
.solfigrplayers {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  --player-table-size: 4.125rem;
  &_title {
    margin: 0 0 0.325rem 0;
  }
  &_content {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
</style>
